export default __webpack_public_path__ + "static/media/RelaciondeParticipantes_invitacionpublica.2593ea52.docx";